import {RootState} from 'hiya-common/src/stores'

import {logFun} from './axios'
import {resolveActionName, resolvePageName} from './resolvePageName'

let renderStartReported = false

/**
 * 埋点 1：开始渲染（hydrate 之前）
 * action: show, otype: h5_pages
 */
export function reportRenderStart(env: RootState['env']) {
  if (renderStartReported) {
    return
  }

  try {
    const pagePath = env.path || window.location.pathname
    const page_name = resolvePageName(pagePath)
    const {from = ''} = env.otherInfo || {}
    let pre_load = false
    try {
      pre_load =
        typeof window !== 'undefined' &&
        localStorage.getItem('preloading') === 'true'
    } catch (e) {}

    logFun(env)({
      action: 'show',
      otype: 'h5_pages',
      data: {
        stage: 'render_start',
        action_name: resolveActionName(pagePath),
        page_name,
        page_path: pagePath,
        ...(from && {from}),
        pre_load,
      },
    })
    renderStartReported = true
  } catch (error) {
    if (ENV !== 'production') {
      console.warn('[pageLifecycle] reportRenderStart failed', error)
    }
  }
}
